import { Plugin } from "..";
import { defaultEventBarDataOptions } from "./event-bar-data-options";
import { defaultEventBarOptions } from "./event-bar-options";

const id = "event-bar";

export const EventBar: Plugin = {
	id,
	type: "history",
	header: {
		visible: false,
		edit: true,
		fullscreen: false,
	},
	name: "eventBar",
	component: defineAsyncComponent(() => import("./EventBarPlugin.vue")),
	config: defineAsyncComponent(() => import("./EventBarPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./EventBarDataConfig.vue")),
	defaultDataResolver: () => defaultEventBarDataOptions,
	defaultOptionsResolver: () => defaultEventBarOptions,
	dimension: {
		minWidth: 8,
	},

	currentVersion: 1,
	migrations: {},
};
